module.exports = __webpack_public_path__ + "static/media/DT-UK-2023-White.34202663.png";